import type { FaireProductEntity } from "../../entity_types/product";

export const p_p9v2vx5yqk: FaireProductEntity = {
  token: "p_p9v2vx5yqk",
  type: "product",
  name: "Witch/Wizard Hat Tea Light Cover Halloween Decor",
  brandToken: "b_gvjwg3hjh3",
  brandName: "Prairie City Printing Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/f3e71f5e448fe3a0939195aa42c1afa496877e5a821f4085693cfc85c38f3d8b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f00926f1b519789b0ca2e2e140b32bab20423b26061f3db4d4537abf96240a0.jpeg",
    "https://cdn.faire.com/fastly/312632a68adad33cf98f6edf12530d19285dc54622b8a1916c43d648d92f456a.webp",
  ],
  priceDollars: 5.41,
  description:
    "- LED tealight cover\n- Made from sustainable materials\n- 2 color options\n\nAdd a touch of charm and mystery to your fall decor with our Halloween-inspired Witch Hat LED Tealight Cover. Made to fit a standard small LED tealight, the light shines through the intricate stars and moon and openings, creating a subtle yet enchanting effect.\n\nStyle it on a shelf, table, or mantel — or pair it with one of our matching trays or vases to complete your Halloween, Thanksgiving, or autumn setup. It’s the perfect balance of spooky and sweet.\n\nEach piece is 3D printed in a sleek matte black finish using eco-friendly, plant-based PLA — a biodegradable and non-toxic material.\n\nDimensions:\n• 4 inches tall\n• 3.5 inches wide\n\nAvailable colors:\n\nWhite\nBlack",
  tags: [],
  msrpDollars: 10.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:46.857Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
